<div [hidden]="show === 'none'">
  <div [hidden]="show === 'unverified'">
    <button class="btn btn-sm btn-outline-secondary" type="button">
      <i class="fa fa-check" style="color: #28a745"></i>
    </button>
  </div>  
</div>
